import Vue from 'vue';
import treasuryRts27Query from './treasury-rts27-query/treasury-rts27-query.vue';
import store from '../common/js/vuex/store';
import treasuryRst27Store from './treasury-rts27-query/treasury-rts27-query-vuex';
if (!store.hasModule(['treasuryRst27'])) {
	store.registerModule('treasuryRst27', treasuryRst27Store);
}
Vue.component('treasury-rts27-query', treasuryRts27Query);
